import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Server } from 'lucide-react';
import toolkitService from '../../services/ToolkitService';

// The project's recent server jobs (toolkit jobs.js), on the Toolkit overview: what ran, how it went, who started it,
// and a link back to the screen with the job open (the same link as the completion email).

const STATUS = { STARTING: 'Starting', RUNNING: 'Running', SUCCEEDED: 'Finished', FAILED: 'Error', STOPPED: 'Stopped' };
const TONE = { RUNNING: 'processing', STARTING: 'processing', SUCCEEDED: 'success', FAILED: 'failed', STOPPED: 'skipped' };
const when = (v) => (v ? new Date(v).toLocaleString() : '—');

function ToolkitJobsList({ ctx }) {
    const navigate = useNavigate();
    const [jobs, setJobs] = useState(null);
    useEffect(() => {
        toolkitService.jobs(ctx, 'list', { limit: 15 }).then(({ data }) => setJobs(data.items || [])).catch(() => setJobs([]));
    }, [ctx]);
    if (!jobs || !jobs.length) return null;
    return (
        <section className="tkb-group">
            <h2 className="tkb-group-title"><Server size={16} /> Server jobs</h2>
            <div className="otx-table-wrap">
                <table className="otx-table">
                    <thead><tr><th>Job</th><th>Status</th><th>Succeeded</th><th>Skipped</th><th>Failed</th><th>To go</th><th>Started</th><th>By</th></tr></thead>
                    <tbody>{jobs.map((j) => (
                        <tr key={j.id}>
                            <td>
                                {j.screenPath
                                    ? <button type="button" className="tkb-link" onClick={() => navigate(`${j.screenPath}?job=${j.id}`)}>{j.title}</button>
                                    : j.title}
                            </td>
                            <td><span className={`tkb-badge tkb-status-${TONE[j.status] || 'pending'}`}>{STATUS[j.status] || j.status}</span></td>
                            <td>{j.succeeded}</td><td>{j.skipped}</td><td>{j.failed}{j.other ? ` (+${j.other})` : ''}</td><td>{j.pending}</td>
                            <td>{when(j.startedAt)}</td><td>{j.startedBy || '—'}</td>
                        </tr>
                    ))}</tbody>
                </table>
            </div>
        </section>
    );
}

export default ToolkitJobsList;
